module.exports = __webpack_public_path__ + "img/FullWidthMap.8abaafb2.png";